import { BootstrapUsecaseInterface, GetParameter } from "./usecase.d";
import { BootstrapRepository } from "../../services/Bootstrap/bootstrap.repository";

export class BootstrapUsecase implements BootstrapUsecaseInterface {
  repository: BootstrapRepository;

  constructor() {
    this.repository = new BootstrapRepository();
  }

  async get(params: GetParameter) {
    const { tenantSubDomain } = params;
    const data = await this.repository.getList();
    const matchTenants = data.filter(
      (value) => `portal-${value.tenantSubDomain}` === tenantSubDomain,
    );
    if (matchTenants.length !== 1) {
      throw new Error(
        `Not found bootstrap information match with given subdomain ${tenantSubDomain}`,
      );
    }

    const bootstrapInfo = await this.repository.get({
      tenantId: matchTenants[0].tenantId,
    });
    return bootstrapInfo;
  }
}
